import Cart from './Cart.js';

class CartRepository {

    constructor() {
        this.setItem = function (item) {
            const localCart = this.cart;

            localCart.items = [...localCart.items].map(i => {
                if (i.articleNumber === item.articleNumber) {
                    return { ...i, ...item };
                }
                else {
                    return i;
                }
            });

            let json = JSON.stringify(localCart);
            window.localStorage.setItem("cart", json);
        };

        this.addItem = function (item) {
            let localCart = this.cart;
            localCart.items.push(item);
            let json = JSON.stringify(localCart);
            window.localStorage.setItem("cart", json);
        };

        this.removeItem = function (articleNumber) {
            const localCart = this.cart;
            localCart.items = localCart.items.filter(i => i.articleNumber !== articleNumber)

            let json = JSON.stringify(localCart);
            window.localStorage.setItem("cart", json);
        };

        this.changed = () => {
            const cartChangedEvent = new CustomEvent("CartChanged");
            document.dispatchEvent(cartChangedEvent);
        }
    }

    get cart() {
        const json = window.localStorage.getItem("cart");
        const obj = JSON.parse(json);
        let cart = new Cart();
        if (obj){
            cart = Cart.from(obj);
        } else {
            let json = JSON.stringify(cart);
            window.localStorage.setItem("cart", json);
        }

        return cart;
    }

    add = function(articleNumber, legacyArticleId, quantity) {

        if (quantity === 0){
            this.removeItem(articleNumber);
            return;
        }

        let item = this.cart.items.find(i => i.articleNumber === articleNumber);

        if (item) {
            item.quantity += quantity;
            this.setItem(item);
        }
        else {
            item = { articleNumber: articleNumber, legacyArticleId: legacyArticleId, quantity: quantity };
            this.addItem(item);
        }

        this.changed();
    }

    remove = function(articleNumber){
        this.removeItem(articleNumber);

        this.changed();
    }

    update = function(articleNumber, legacyArticleId, quantity) {

        if (quantity === 0){
            this.removeItem(articleNumber);
            return;
        }

        let item = this.cart.items.find(i => i.articleNumber === articleNumber);

        if (item) {
            item.quantity = quantity;
            this.setItem(item);
        }

        this.changed();
    }

    newCart = function(){
        window.localStorage.removeItem("cart");
        const newCart = this.cart;
        this.changed();
        return newCart;
    }
}

export default CartRepository;